module.exports = __webpack_public_path__ + "f572638f/img/google.68f3823e.svg";